import { Button, Space } from 'antd'
import styled from 'styled-components'

export const SpaceCustom = styled(Space)`
  display: flex;
  justify-content: flex-end;
`

export const GhostButton = styled(Button)`
  background: #000;
  color: #fff;
`
